import * as React from 'react';

function settings( props: React.SVGProps<SVGSVGElement> ) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M33.75 20.95v-1.912l2.4-2.1a2.5 2.5 0 00.475-3.188l-2.95-5a2.5 2.5 0 00-2.162-1.25 2.5 2.5 0 00-.8.125L27.675 8.65a14.197 14.197 0 00-1.637-.937l-.638-3.15a2.5 2.5 0 00-2.5-2.013h-5.85a2.5 2.5 0 00-2.5 2.013l-.637 3.15c-.57.275-1.122.588-1.65.937L9.288 7.575a2.5 2.5 0 00-.8-.075 2.5 2.5 0 00-2.163 1.25l-2.95 5a2.5 2.5 0 00.513 3.137L6.25 19.05v1.912l-2.362 2.1a2.5 2.5 0 00-.513 3.188l2.95 5a2.5 2.5 0 002.163 1.25c.271.002.541-.04.8-.125l3.037-1.025c.525.348 1.072.662 1.638.938l.637 3.15a2.5 2.5 0 002.5 2.012H23a2.5 2.5 0 002.5-2.013l.638-3.15c.57-.275 1.12-.588 1.65-.937l3.025 1.025c.258.085.528.127.8.125a2.5 2.5 0 002.162-1.25l2.85-5a2.5 2.5 0 00-.512-3.137L33.75 20.95zM31.513 30l-4.288-1.45a11.074 11.074 0 01-3.387 1.962L22.95 35h-5.9l-.887-4.438a11.698 11.698 0 01-3.375-1.962l-4.3 1.4-2.95-5 3.4-3a11.125 11.125 0 010-3.913L5.538 15l2.95-5 4.287 1.45a11.074 11.074 0 013.388-1.962L17.05 5h5.9l.888 4.438a11.701 11.701 0 013.375 1.962l4.3-1.4 2.95 5-3.4 3a11.126 11.126 0 010 3.913l3.4 3.087-2.95 5z"
				fill="currentColor"
			/>
			<path
				d="M20 27.5a7.5 7.5 0 117.5-7.5 7.425 7.425 0 01-7.5 7.5zM20 15a4.888 4.888 0 00-5 5 4.888 4.888 0 005 5 4.888 4.888 0 005-5 4.888 4.888 0 00-5-5z"
				fill="currentColor"
			/>
		</svg>
	);
}

export default settings;
